import React from "react";
import AssetTable from "./AssetTable";
import AssetReferences from "./AssetReferences";
import NewAssetFee from "./NewAssetFee";
import { AssetTheme } from "../Theme";
import { Grid, Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import { ThemeProvider } from "@material-ui/core/styles";
import useAssetProvider from "./useAssetProvider";


const UseStyles = makeStyles((theme) => ({
  main_grid: {
    backgroundColor: "#F5F5F5",
    
  },
  main_grid_atoka: {
    backgroundColor: "#E6E6FA" ,
      
  },
  box_design: {
    border: "3px solid rgba(224, 224, 224, 1)",
    padding: 10,
    borderRadius: 20,
  },
}));

const Asset = ({ addAssetModalOpen, setAddAssetModalOpen }) => {
  const classes = UseStyles();
  const { app } = useAssetProvider();
     
  return (
    <ThemeProvider theme={AssetTheme}  bgcolor="background.paper">     
      <Box className={(app.record_type == "Atoka")? classes.main_grid_atoka : classes.main_grid} p={1} >
        <Grid container spacing={1} className={classes.box_design}>
          <Grid align="left" item xs={12}>
            <NewAssetFee
              open={addAssetModalOpen}
              setOpen={setAddAssetModalOpen}
            />
            <TableContainer>
              <Table aria-label="simple table">
                <TableBody>
                  <TableRow>
                    <TableCell align="left">
                      <Typography variant="h6" style={{ color: "#7F9F09" }}>
                        {app.id}
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <AssetReferences />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <AssetTable onClickAssetAdd={setAddAssetModalOpen} />
          </Grid>
        </Grid>
      </Box>
    </ThemeProvider>
  );
};
export default Asset;
